import * as actionTypes from '../actions/ActionTypes';
import * as api from '../../shared/services/api/apiDashBoard';

import { all, put, takeEvery } from 'redux-saga/effects';
import {
  OFFLINE_USER,
  SESSION_EXPIRED,
  SESSION_EXPIRED_CODE,
  SOMETHING_WRONG,
  Strings,
} from '../../shared/constants/Constants';
import {
  Logout,
  startLoading,
  stopLoading,
  updateChallengeAcceptList,
  updateChallengeHistoryList,
  updateChallengeList,
  updateDashBoardTestResult,
  updateLeaderBoardDetails,
} from '../actions';

import { checkOffline } from '../../shared/services/Utility';

function* fetchTestResults(action) {
  try {
    yield put(startLoading());

    let data = yield api.fetchDashBoardTestResult(action.params);

    if (data.status === 1) {
      yield put(stopLoading());
      //data fetched
      yield put(updateDashBoardTestResult(data.data));
    } else if (data.status === SESSION_EXPIRED_CODE) {

      /*session id expired*/
      yield put(stopLoading());
      action.errorSnackbar(SESSION_EXPIRED, 'error');
      yield put(Logout());
    } else {
      yield put(stopLoading());
    }
  } catch (e) {
    yield put(stopLoading());
    if (checkOffline()) {
      action.errorSnackbar(OFFLINE_USER, 'error');
    } else {
      action.errorSnackbar(SOMETHING_WRONG, 'error');
    }
  }
}

function* OnChangePassword(action) {
  try {
    yield put(startLoading());

    const data = yield api.onChangePassword(action.changePasswordData);
    if (data.status === 1) {
      action.success();
      // Alert.alert(
      //   APP_NAME,
      //   "password successfully changed, please login again."
      // );
      //   yield put(Logout());

      yield put(stopLoading());
    } else if (data.status === SESSION_EXPIRED_CODE) {

      /*session id expired*/
      yield put(stopLoading());
      action.openSnackbar(SESSION_EXPIRED, 'error');
      yield put(Logout());
    } else if (data.status === 0) {
      yield put(stopLoading());
      action.openSnackbar(Strings.invalidOldPassword, 'error');
    } else {
      action.openSnackbar(data.message, 'error');
      yield put(stopLoading());
      // Alert.alert(APP_NAME, "Invalid old password");
    }
  } catch (e) {
    if (checkOffline()) {
      action.errorSnackbar(OFFLINE_USER, 'error');
    } else {
      action.errorSnackbar(SOMETHING_WRONG, 'error');
    }
    // alert('error ==  ' + e)
  } finally {
    yield put(stopLoading());
  }
}

/************ Dashboard sagas for Challenge List   *********/

function* fetchChallengeSendList(action) {

  try {
    let res = yield api.fetchChallengeSendListAPI(action.params);

    if (res.status === 1) {
      //data fetched
      // alert(res.data)
      yield put(updateChallengeList(res.data));
    } else if (res.status === SESSION_EXPIRED_CODE) {
      /*session id expired*/
      yield put(stopLoading());
      action.callback(SESSION_EXPIRED, 'error');
      yield put(Logout());
      // yield put(goto_login())
    }
  } catch (e) {

    yield put(stopLoading());
    if (checkOffline()) {
      action.callback(OFFLINE_USER, 'error');
    } else {
      action.callback(SOMETHING_WRONG, 'error');
    }
  }
}

function* fetchChallengeAcceptList(action) {
  try {
    let res = yield api.fetchChallengeAcceptListAPI(action.params);

    // alert(JSON.stringify(res))
    if (res.status === 1 || res.status === 200) {
      //data fetched
      // alert(JSON.stringify(res.data))
      yield put(updateChallengeAcceptList(res.data));
    } else if (res.status === SESSION_EXPIRED_CODE) {
      /*session id expired*/
      yield put(stopLoading());
      action.callback(SESSION_EXPIRED, 'error');
      yield put(Logout());
      // yield put(goto_login())
    }
  } catch (e) {
    yield put(stopLoading());
    if (checkOffline()) {
      action.callback(OFFLINE_USER, 'error');
    } else {
      action.callback(SOMETHING_WRONG, 'error');
    }
  }
}

function* fetchTheLeaderboardDetails(action) {
  try {
    // yield put(startLoading());
    let res = yield api.fetchLeaderBoardDetails(action.params);
    if (res.status === 1) {
      //data fetched
      // alert(res.data)
      yield put(updateLeaderBoardDetails(res.data));
    } else if (res.status === SESSION_EXPIRED_CODE) {
      /*session id expired*/
      yield put(stopLoading());
      action.callback(SESSION_EXPIRED, 'error');
      yield put(Logout());
    }
    yield put(stopLoading());
  } catch (e) {
    yield put(stopLoading());
    if (checkOffline()) {
      action.callback(OFFLINE_USER, 'error');
    } else {
      action.callback(SOMETHING_WRONG, 'error');
    }
  }
}

function* fetchChallengeHistoryList(action) {
  try {
    let res = yield api.fetchChallengeHistoryListAPI(action.params);
    // alert(JSON.stringify(res))

    if (res.status === 1 || res.status === 200) {
      //data fetched
      // alert(res.data)
      yield put(updateChallengeHistoryList(res.data));
    } else if (res.status === SESSION_EXPIRED_CODE) {
      /*session id expired*/
      // if (!Utility.isAlertShowing) {
      //   Utility.updateAlertShowing(true);
      //   Alert.alert(APP_NAME, SESSION_EXPIRED, [
      //     {
      //       text: "OK",
      //       onPress: () => {
      //         Utility.updateAlertShowing(false);
      //       },
      //     },
      //   ]);
      // yield put(goto_login())
      yield put(stopLoading());
      action.callback(SESSION_EXPIRED, 'error');
      yield put(Logout());
      // }
    }
  } catch (e) {
    // alert('error')
    yield put(stopLoading());
    if (checkOffline()) {
      action.callback(OFFLINE_USER, 'error');
    } else {
      action.callback(SOMETHING_WRONG, 'error');
    }
  }
}

function* DashboardSaga() {
  yield all([
    takeEvery(actionTypes.FETCH_DASHBOARD_DETAILS, fetchTestResults),
    takeEvery(actionTypes.CHANGE_PASSWORD, OnChangePassword),
    takeEvery(actionTypes.FETCH_CHALLENGE_SEND_LIST, fetchChallengeSendList),
    takeEvery(
      actionTypes.FETCH_CHALLENGE_ACCEPT_LIST,
      fetchChallengeAcceptList,
    ),
    takeEvery(
      actionTypes.FETCH_LEADERBOARD_DETAILS,
      fetchTheLeaderboardDetails,
    ),

    takeEvery(
      actionTypes.FETCH_CHALLENGE_HISTORY_LIST,
      fetchChallengeHistoryList,
    ),
  ]);
}

export default DashboardSaga;
